import React from 'react';


const ContactUs = (props) => {
    if (props.match.params.ProductId) {

    }
    return (
        <>
        </>
    )
}

export default ContactUs;